var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { cleanCompanyData, cleanPlantingData } from "./cleaner";
import { ORGID } from "./index";
/**
 * Get all API data
 *
 * @param orgId The organization ID to get data for (defaults to us).
 * @param fetcher The function to use to fetch the data. Defaults to the API
 *   fetcher.
 * @returns The cleaned company and planting data
 */
export function getAPIData() {
    return __awaiter(this, arguments, void 0, function* (orgId = ORGID, fetcher = queryAPI) {
        const toFetch = [
            {
                endpoint: `orgs/pstats?org_id=${orgId}&org_type=sponsorAccount&_v=11.0.0`,
            },
            {
                endpoint: `sponsors/${orgId}/map-data?_v=11.0.0`,
            },
        ];
        const responses = yield Promise.allSettled(toFetch.map((fetch) => __awaiter(this, void 0, void 0, function* () {
            return yield fetcher(fetch.endpoint);
        })));
        if (responses[0].status === "rejected" ||
            responses[1].status === "rejected") {
            throw new Error("Failed to fetch data from the API");
        }
        return {
            companyData: cleanCompanyData(responses[0].value),
            plantingData: cleanPlantingData(responses[1].value),
        };
    });
}
/**
 * Query the API and extract the JSON response.
 *
 * @param url The endpoint to query
 * @returns The JSON response
 * @throws Error if the response is not OK
 */
function queryAPI(url) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fetch(`https://api.veritree.com/api/${url}/`);
        if (!response.ok)
            throw new Error(`Error getting API data from ${url}: ${response.statusText}`);
        const data = yield response.json();
        return data;
    });
}
